import { RodDto } from '../dto/rod.dto';

export function formatRodListName(item: RodDto): string {
    let newName;

    if (item.name) {
        newName = item.name;
    } else {
        if (item.contactCount === 1) {
            newName = item.title?.replace('ROD Request - ', '') ?? null;
        } else {
            const index = item.subject.indexOf('ROD Request - ');
            newName = index !== -1 ? item.subject.slice(index + 'ROD Request - '.length) : item.subject;
        }                            
        if (!newName) {
            newName = item.zendeskTicket || "";
        }
    }
    
    if (newName?.endsWith("RevDriver")) {
        newName = `[${item.zendeskTicket}] RevDriver`;
    } else {
        newName = `[${item.zendeskTicket}] ${newName}`;
    }

    return newName;
}
